const checkCaseGrade = async (
  examGuid,
  route,
  userData,
  displayAuthenticationError
) => {
  return await fetch(`${route}/checkgradingstatus.webapi`, {
    method: "POST",
    headers: {
      Token: userData.Token,
      "Content-Type": "text/plain",
    },
    body: JSON.stringify({
      examGuid: examGuid,
    }),
  })
    .then((response) => {
      if (response.status === 401) {
        displayAuthenticationError();
        throw new Error("Authentication Error");
      } else {
        return response.json();
      }
    })
    .then((response) => {
      console.log("checked Data", response);

      return {
        checkedData: response,
      };
    });
};

export default checkCaseGrade;
